import Vue from 'vue';
import store from './store';
import router from './router/';
import App from './App.vue';
import './plugins/element.js';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');
